<template>
        <div class="site__body">
            <div class="block-space block-space--layout--after-header"></div>
            <div class="block">
                <div class="container container--max--xl">
                    <div class="row">
                      <account-navigation></account-navigation>
                      <invoice-details></invoice-details>
                    </div>
                </div>
            </div>
            <div class="block-space block-space--layout--before-footer"></div>
        </div>
</template>

<script>

import AccountNavigation from '../accountnavigation/AccountNavigation';
import InvoiceDetails from './InvoiceDetails';

export default {
  name: 'OrderHistory',
  components: {
    AccountNavigation,
    InvoiceDetails    
  },
  created() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });
  }
}
</script>